import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Render immediately, then lazy-load Sentry after first paint
createRoot(document.getElementById("root")!).render(<App />);

// Defer Sentry initialization so it doesn't block initial render
if (import.meta.env.PROD) {
  requestIdleCallback?.(() => {
    import("./lib/sentry").then(({ initSentry }) => initSentry());
  }) ??
    setTimeout(() => {
      import("./lib/sentry").then(({ initSentry }) => initSentry());
    }, 2000);
}
